//import Container from "@mui/material/Container";
//import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
//import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import { useQuery } from "@apollo/client";
import { FIND_LINKS_BY_SECTION, FIND_VOTES_BY_SECTION } from "queries";
import { Button, Card, CardContent } from "@mui/material";
//import { Link } from "react-router-dom";

// Material Kit 2 React examples
//import DefaultFooter from "examples/Footers/DefaultFooter";
//import Card from "@mui/material/Card";
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/links/DesignBlocks";
//import Pages from "pages/Presentation/links/Pages";
//import Testimonials from "pages/Presentation/links/Testimonials";
//import Download from "pages/Presentation/links/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";
import React, { useState, useEffect } from "react";
// Routes
//import routes from "routes";
//import footerRoutes from "footer.routes";
// Images
//import bgImage from "assets/images/strategia.jpg";
//import { ALL_MUNICIPALITIES } from "queries";
import { useParams } from "react-router-dom";
/* eslint-disable react/prop-types */
// eslint-disable-next-line
const Linkspublic = ({ selectedKunta, setSelectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //console.log(selectedKunta);
  //console.log(setSelectedKunta);
  let section = useParams().id;
  const [links, setLinks] = useState([]);
  const [votes, setVotes] = useState([]);
  //console.log(votes);
  const votessw = useQuery(FIND_VOTES_BY_SECTION, {
    pollInterval: 100000,
    variables: { section },
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesBySection;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.linkid === p).length;
  }
  //const [idea, setIdea] = useState("");
  //const [selected, setSelected] = useState("Kommentit");
  //const [ideas, setIdeas] = useState([]);
  //const [ideatext, setIdeatext] = useState("");
  //const [selected, setSelected] = useState([]);
  const linkssw = useQuery(FIND_LINKS_BY_SECTION, {
    pollInterval: 100000,
    variables: { section: section },
  });

  /*useEffect(() => {
    let valittu = links.filter(function (el) {
      return el.agendaid === meeting;
    });
    //console.log(valittu);
    setSelected(valittu);
  }, [selectedKunta, links]);*/
  useEffect(() => {
    let linkss = [];
    //let municipalitiess = [];
    if (linkssw.data) {
      //console.log(linkssw.data);
      linkss = linkssw.data.findLinksBySection;
      //setOrgans(organss);
      //console.log(linkss);
      //let secs = linkss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setlinks(secs);
      setLinks(linkss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [linkssw]);
  const handleVote = () => {
    window.confirm("Sinun on kirjauduttava voidaksesi äänestää");
  };
  return (
    <>
      <MKTypography
        variant="h1"
        color="black"
        mt={-6}
        mb={1}
        sx={({ breakpoints, typography: { size } }) => ({
          [breakpoints.down("md")]: {
            fontSize: size["3xl"],
          },
        })}
      >
        Linkit
      </MKTypography>
      {links.map((p, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>
              {p.linktext}
              {"(" + p.linktype + ")"}:{" "}
              <a href={p.linkref} target="0">
                {p.linkref}
              </a>
            </MKTypography>
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={() => handleVote(index)}
            >
              👍 {voteCount(p.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Linkspublic;
